import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCommonSelector } from '@wajeez-web/stores/common';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

import InputLabel from '../Inputs/InputLabel';
import { NumberInputTypeV2 } from './types';

export const NumberInputV2 = React.forwardRef<
  HTMLInputElement,
  NumberInputTypeV2
>(
  (
    {
      id,
      label,
      placeholder = '',
      disabled,
      required = false,
      shape = 'squre',
      textColorClassName = 'text-textPrimary',
      bgColorClassName = 'bg-white',
      value,
      onChange,
      prefix,
      suffix,
      inputExtraClassNames,
      isError,
      fieldState,
      max,
      min,
      span,
    },
    ref
  ) => {
    const { dir } = useCommonSelector((state) => state.common.settings);

    const { t } = useTranslation();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;

      onChange && onChange(value === '0' ? value : Number(value));
    };

    return (
      <div className="w-full">
        {label && (
          <InputLabel
            text={t(`inputs.labels.${label}`, label.toString() || '') as string}
            name={id ?? ''}
            required={required}
            hint={span}
          />
        )}{' '}
        <div
          className={`relative  ${
            shape === 'circle' ? 'rounded-full' : 'rounded-md'
          } `}
        >
          {prefix && (
            <div
              className={`absolute inset-y-0 ltr:left-0 rtl:right-0 w-full  pl-3 flex items-center pointer-events-none`}
            >
              <span className="text-gray-500 sm:text-sm">{prefix}</span>
            </div>
          )}
          <input
            ref={ref}
            type="number"
            disabled={disabled}
            max={max}
            min={min}
            required={required}
            value={value?.toString() || ''}
            onChange={(s) => {
              handleChange(s);
            }}
            className={`w-full py-1 lg:py-2 sm:text-sm border-gray-300 border ${
              !isError
                ? 'focus:border-primary focus:ring-0 focus:ring-primary'
                : 'focus:border-red-500 focus:ring-0 focus:ring-red-500'
            } ${shape === 'circle' ? 'rounded-full' : 'rounded-md'} ${
              prefix && dir === 'rtl'
                ? 'pr-7'
                : suffix && dir === 'ltr' && 'pl-7'
            } ${bgColorClassName} ${textColorClassName} ${inputExtraClassNames}`}
            placeholder={
              t(
                `inputs.placeholders.${placeholder}`,
                placeholder || ''
              ) as string
            }
          />
          {isError && (
            <div className="absolute top-[105%] right-0 text-[12px] text-red-500">
              <ReturnTranslatedText
                origintext={fieldState?.error?.message}
                text={`general.${fieldState?.error?.message}`}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
);

export const parseNumber = (value: string) => {
  const parsedValue = parseFloat(value);
  return isNaN(parsedValue) ? undefined : parsedValue;
};
